import * as TYPES from '../types';

export const addCollaborationAction = (payload) => {
    return {
        type: TYPES.ADD_COLLABORATION,
        payload: payload
    };
};

export const getAllCollaborationAction = () => {
    return {
        type: TYPES.GET_ALL_COLLABORATION,
    };
};

export const getAllCollaborationSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_COLLABORATION_SUCCESS,
        payload: payload
    };
};

export const deleteCollaborationAction = (payload) => {
    return {
        type: TYPES.DELETE_COLLABORATION,
        payload: payload
    };
};

export const editCollaborationAction = (payload) => {
    return {
        type: TYPES.EDIT_COLLABORATION,
        payload: payload
    };
};

export const udpateCollaborationStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_COLLABORATION_STATUS,
        payload: payload
    };
};
